// @flow
import gql from 'graphql-tag';
import type {AlternativeLink} from '../components/HtmlTitle/HtmlTitle';

export type SeoMetaDataParamsType = {
    adultsCount?: number,
    children?: number,
    childrenCount?: number,
    filter?: string[],
    hitCount?: number,
    lastBreadcrumbNode?: string,
    maxBathrooms?: number,
    maxBedrooms?: number,
    minBathrooms?: number,
    minBedrooms?: number,
    maxNightlyPrice?: number,
    minNightlyPrice?: number,
    page: number,
    pageSize: number,
    petIncluded: boolean,
    lbsId?: string
};

export type SeoMetaData = {
    metaKeywords?: string,
    pageTitle?: string,
    metaDescription?: string,
    headlineTitle?: string,
    searchReviewsHeadline?: string,
    canonicalLink?: string,
    alternativeLinks?: AlternativeLink[]
};

export type SeoMetaDataResponseData = {
    seoMetaData: ?SeoMetaData,
    error?: Error,
    loading: boolean,
    variables: {
        args: SeoMetaDataParamsType,
        isSearchRoot: boolean
    }
};

const seoMetaDataQuery = gql`
    query seoMetaDataQuery($args: SeoMetaDataParams!, $isSearchRoot: Boolean!) {
        seoMetaData(args: $args) {
            metaKeywords
            pageTitle
            metaDescription
            headlineTitle
            searchReviewsHeadline
            canonicalLink
            alternativeLinks @include(if: $isSearchRoot) {
                link
                hrefLang
            }
        }
    }
`;

export default seoMetaDataQuery;
